var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseExportContact",
    {
      attrs: {
        postFixer: _vm.postFixer,
        inputRequireHighlight: _vm.inputRequireHighlight,
        maxBuildingsPerExport: _vm.maxBuildingsPerExport,
        selectedBuildings: _vm.selectedBuildings,
      },
      on: {
        "update:selectedBuildings": function ($event) {
          _vm.selectedBuildings = $event
        },
        "update:selected-buildings": function ($event) {
          _vm.selectedBuildings = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "contact-category",
          class: {
            "required-error-highlight":
              _vm.inputRequireHighlight &&
              !_vm.workingHourChecked &&
              !_vm.nonWorkingHourChecked,
          },
          attrs: { slot: "addtional-content" },
          slot: "addtional-content",
        },
        [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("contacts.contactCategory")) + ":"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-options" }, [
            _c("input", {
              attrs: { id: "pages-ccd-export-emergency-all", type: "checkbox" },
              domProps: {
                checked: _vm.workingHourChecked && _vm.nonWorkingHourChecked,
              },
              on: {
                change: function (event) {
                  return _vm.updateCategory(event.target.checked)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "items",
                attrs: { for: "pages-ccd-export-emergency-all" },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("all")) + "\n      ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-options" }, [
            _c("input", {
              attrs: { id: "pages-ccd-export-emergency-wh", type: "checkbox" },
              domProps: { checked: _vm.workingHourChecked },
              on: {
                change: function (event) {
                  _vm.workingHourChecked = event.target.checked
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "items",
                attrs: { for: "pages-ccd-export-emergency-wh" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("general.officeHrs")) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-options" }, [
            _c("input", {
              attrs: { id: "pages-ccd-export-emergency-nwh", type: "checkbox" },
              domProps: { checked: _vm.nonWorkingHourChecked },
              on: {
                change: function (event) {
                  _vm.nonWorkingHourChecked = event.target.checked
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "items",
                attrs: { for: "pages-ccd-export-emergency-nwh" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("general.afterOfficeHrs")) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }